export default `.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  margin: 0;
}
.vuiFlexContainer--spacingNone > .vuiFlexItem {
  margin: 0;
}

.vuiFlexContainer--spacingXxs {
  margin: -2px;
}
.vuiFlexContainer--spacingXxs > .vuiFlexItem {
  margin: 2px;
}

.vuiFlexContainer--spacingXs {
  margin: -4px;
}
.vuiFlexContainer--spacingXs > .vuiFlexItem {
  margin: 4px;
}

.vuiFlexContainer--spacingS {
  margin: -6px;
}
.vuiFlexContainer--spacingS > .vuiFlexItem {
  margin: 6px;
}

.vuiFlexContainer--spacingM {
  margin: -8px;
}
.vuiFlexContainer--spacingM > .vuiFlexItem {
  margin: 8px;
}

.vuiFlexContainer--spacingL {
  margin: -12px;
}
.vuiFlexContainer--spacingL > .vuiFlexItem {
  margin: 12px;
}

.vuiFlexContainer--spacingXl {
  margin: -16px;
}
.vuiFlexContainer--spacingXl > .vuiFlexItem {
  margin: 16px;
}

.vuiFlexContainer--spacingXxl {
  margin: -20px;
}
.vuiFlexContainer--spacingXxl > .vuiFlexItem {
  margin: 20px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiSpinner--accent svg path,
.vuiSpinner--accent svg rect {
  fill: #551edf;
}

.vuiSpinner--primary svg path,
.vuiSpinner--primary svg rect {
  fill: rgb(38, 76, 214);
}

.vuiSpinner--success svg path,
.vuiSpinner--success svg rect {
  fill: #04821f;
}

.vuiSpinner--danger svg path,
.vuiSpinner--danger svg rect {
  fill: #c41535;
}

.vuiSpinner--warning svg path,
.vuiSpinner--warning svg rect {
  fill: #965a15;
}

.vuiSpinner--empty svg path,
.vuiSpinner--empty svg rect {
  fill: #ffffff;
}

.vuiSpinner--dark svg path,
.vuiSpinner--dark svg rect {
  fill: #2c313a;
}

.vuiSpinner--xs {
  width: 14px;
  height: 14px;
}

.vuiSpinner--s {
  width: 15.9px;
  height: 15.9px;
}

.vuiSpinner--m {
  width: 20.08px;
  height: 20.08px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiToggle {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.vuiToggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vuiToggle__input:checked + .vuiToggle__button {
  background-color: rgb(38, 76, 214);
}
.vuiToggle__input:focus-visible + .vuiToggle__button {
  outline: 2px solid rgba(38, 76, 214, 0.75);
  outline-offset: 2px;
}
.vuiToggle__input:checked + .vuiToggle__button:before {
  transform: translateX(16px);
}

.vuiToggle__button {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbcdde;
  transition: 0.2s;
  border-radius: 16px;
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}
.vuiToggle__button:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 50%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText a {
  color: rgb(38, 76, 214);
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}

.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  margin: 0;
}
.vuiFlexContainer--spacingNone > .vuiFlexItem {
  margin: 0;
}

.vuiFlexContainer--spacingXxs {
  margin: -2px;
}
.vuiFlexContainer--spacingXxs > .vuiFlexItem {
  margin: 2px;
}

.vuiFlexContainer--spacingXs {
  margin: -4px;
}
.vuiFlexContainer--spacingXs > .vuiFlexItem {
  margin: 4px;
}

.vuiFlexContainer--spacingS {
  margin: -6px;
}
.vuiFlexContainer--spacingS > .vuiFlexItem {
  margin: 6px;
}

.vuiFlexContainer--spacingM {
  margin: -8px;
}
.vuiFlexContainer--spacingM > .vuiFlexItem {
  margin: 8px;
}

.vuiFlexContainer--spacingL {
  margin: -12px;
}
.vuiFlexContainer--spacingL > .vuiFlexItem {
  margin: 12px;
}

.vuiFlexContainer--spacingXl {
  margin: -16px;
}
.vuiFlexContainer--spacingXl > .vuiFlexItem {
  margin: 16px;
}

.vuiFlexContainer--spacingXxl {
  margin: -20px;
}
.vuiFlexContainer--spacingXxl > .vuiFlexItem {
  margin: 20px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiSpinner--accent svg path,
.vuiSpinner--accent svg rect {
  fill: #551edf;
}

.vuiSpinner--primary svg path,
.vuiSpinner--primary svg rect {
  fill: rgb(38, 76, 214);
}

.vuiSpinner--success svg path,
.vuiSpinner--success svg rect {
  fill: #04821f;
}

.vuiSpinner--danger svg path,
.vuiSpinner--danger svg rect {
  fill: #c41535;
}

.vuiSpinner--warning svg path,
.vuiSpinner--warning svg rect {
  fill: #965a15;
}

.vuiSpinner--empty svg path,
.vuiSpinner--empty svg rect {
  fill: #ffffff;
}

.vuiSpinner--dark svg path,
.vuiSpinner--dark svg rect {
  fill: #2c313a;
}

.vuiSpinner--xs {
  width: 14px;
  height: 14px;
}

.vuiSpinner--s {
  width: 15.9px;
  height: 15.9px;
}

.vuiSpinner--m {
  width: 20.08px;
  height: 20.08px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiToggle {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.vuiToggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vuiToggle__input:checked + .vuiToggle__button {
  background-color: rgb(38, 76, 214);
}
.vuiToggle__input:focus-visible + .vuiToggle__button {
  outline: 2px solid rgba(38, 76, 214, 0.75);
  outline-offset: 2px;
}
.vuiToggle__input:checked + .vuiToggle__button:before {
  transform: translateX(16px);
}

.vuiToggle__button {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbcdde;
  transition: 0.2s;
  border-radius: 16px;
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}
.vuiToggle__button:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 50%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText a {
  color: rgb(38, 76, 214);
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}

body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vrsAnswerContainer {
  border-top: 1px solid #e3e4f3;
  padding: 16px 24px;
}

.vrsSearchForm {
  position: relative;
  display: flex;
  align-items: center;
}

.vrsSearchInput {
  flex-grow: 1;
  padding: 24px;
  background-color: #ffffff;
  border: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  outline-width: 1px;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px;
  font-size: 18px;
  color: #2c313a;
}

.vrsCloseButtonWrapper {
  display: none;
  padding-left: 16px;
}

.vrsSubmitButtonWrapper {
  padding-right: 16px;
}

.vrsSubmitButton {
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vrsSubmitButton:hover {
  color: rgb(38, 76, 214);
}

@media only screen and (max-width: 740px) {
  .vrsCloseButtonWrapper {
    display: initial;
  }
}
.vrsSearchResult {
  background-color: #ffffff;
  display: block;
  padding: 12px 24px 12px 24px;
  text-decoration: none;
  border-bottom: 1px solid #e3e4f3;
}
.vrsSearchResult:hover {
  background-color: #f3f7fb;
}
.vrsSearchResult:last-of-type {
  border-bottom: none;
}

.vrsSearchResult-isLink {
  padding-left: 16px;
  border-left: 12px solid #ffffff;
}
.vrsSearchResult-isLink:hover, .vrsSearchResult-isLink.isSelected {
  border-left: 12px solid rgb(38, 76, 214);
}
.vrsSearchResult-isLink:hover .vrsSearchResultTitle, .vrsSearchResult-isLink.isSelected .vrsSearchResultTitle {
  text-decoration: underline;
}
.vrsSearchResult-isLink .vrsSearchResultTitle {
  color: rgb(38, 76, 214);
}

.vrsSearchResultTitle {
  color: #2c313a;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 4px;
}

.vrsSearchResultSnippet {
  color: #2c313a;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
}

:host {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.vrsSearchModalContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  animation: modalIn 0.2s cubic-bezier(0, 1, 1, 1);
  pointer-events: none;
}
.vrsSearchModalContainer .vrsSearchModal {
  margin-top: 6vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 720px;
  max-height: 88vh;
  z-index: 12;
  pointer-events: all;
  background-color: #ffffff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 8px;
  overflow: hidden;
}
.vrsSearchModalContainer .vrsSearchModalResults {
  border-top: 1px solid #e3e4f3;
  overflow-y: auto;
}

@media only screen and (max-width: 740px) {
  .vrsSearchModalContainer {
    overflow-y: auto;
  }
  .vrsSearchModalContainer .vrsSearchModal {
    margin-top: 0 !important;
    max-width: 100vw !important;
    max-height: none !important;
    border-radius: 0 !important;
    overflow: initial !important;
  }
  .vrsSearchModalContainer .vrsSearchModalResults {
    overflow-y: none !important;
  }
}
:host {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

/**
 * A one-off reset for the button elements.
 */
button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

.vrsSearchButton {
  display: flex;
  width: 100%;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  line-height: 1;
  border: 1px solid #cbcdde;
  color: #2c313a;
  background-color: #ffffff;
  font-size: 16px;
  padding: 8px 1px 8px 12px;
  height: 34px;
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
}
.vrsSearchButton:hover {
  border-color: rgb(38, 76, 214);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  z-index: 1;
}

.vrsSearchButton__inner {
  flex-grow: 1;
}

.vrsSearchButtonShortcut {
  padding: 8px;
  border-radius: 2px;
  font-size: 14px;
  background-color: rgb(217, 226, 255);
  color: rgb(38, 76, 214);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
